var exports = {
  "zr": "root__LyUll9",
  "op": "infoContainer__TY4lAD" + " " + "bannerBase__C-Us33",
  "G": "infoIcon__VIja8_",
  "aV": "infoText__u-MM61",
  "YI": "docsButton__JzmhHk",
};

module.exports = exports;
